import React from 'react'
import { WizTableForm, WizJointExhibition } from '../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const positionCategoryConfig = WizTableForm.Config.positionCategory()

export default (self, other = {}) => {
    let columns = []
    let { type } = other
    if (type.indexOf('Org') !== -1) {
        columns = columns.concat([{
            title: 'orgId',
            name: 'orgId',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '管理组织',
            name: 'orgIdList',
            searchItem: {
                ...organizationConfig,
                diy: WizTableForm,
            }
        }, {
            title: '管理组织',
            name: 'orgId',
            formItem: {
                ...organizationConfig,
                diy: WizTableForm,
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择管理组织',
                }]
            }
        }, {
            title: '管理组织',
            name: 'orgName',
            tableItem: {}
        }, {
            title: '组织编码',
            name: 'links',
            formItem: {
                type: 'diy',
                links: 'orgId',
                diy: ({ linksValues }) => {
                    let wizJointExhibitionProps = {
                        type: 'org',
                        data: linksValues
                    }
                    return <WizJointExhibition {...wizJointExhibitionProps} />
                }
            }
        }, {
            title: '管理组织编码',
            name: 'orgCode',
            tableItem: {},
            // formItem: {
            //     disabled: true,
            //     placeholder: ' '
            // }
        }])
    }
    if (type.indexOf('PositionCategory') != -1) {
        columns = columns.concat([{
            title: 'positionCategoryId',
            name: 'positionCategoryId',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '管理岗位分类',
            name: 'positionCategoryIdList',
            searchItem: {
                ...positionCategoryConfig,
                diy: WizTableForm,
            }
        }, {
            title: '管理岗位分类',
            name: 'positionCategoryId',
            formItem: {
                ...positionCategoryConfig,
                diy: WizTableForm,
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择管理岗位分类',
                }]
            }
        }, {
            title: '管理岗位分类',
            name: 'positionCategoryName',
            tableItem: {}
        }])
    } else {
        columns = columns.concat([{
            title: 'positionId',
            name: 'positionId',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '管理岗位',
            name: 'positionIdList',
            searchItem: {
                ...positionConfig,
                diy: WizTableForm,
            }
        }, {
            title: '管理岗位',
            name: 'positionId',
            formItem: {
                ...positionConfig,
                diy: WizTableForm,
                type: 'diy',
                links: { 'orgId': '管理组织' },
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择管理岗位',
                }]
            }
        }, {
            title: '管理岗位',
            name: 'positionName',
            tableItem: {}
        }])
    }

    columns = columns.concat([{
        title: 'id',
        name: 'id',
        formItem: {
            type: 'hidden'
        }
    },
    {
        title: '状态',
        name: 'state',
        dict: [
            { code: 1, codeName: "有效" },
            { code: 0, codeName: "无效" }
        ],
        searchItem: {
            type: 'select',
        },
        tableItem: {},
        formItem: {
            type: "radio",
            initialValue: 1
        }
    },
    {
        title: '创建时间',
        name: 'createTime',
        tableItem: {}
    }])
    return columns
}